module.exports = __webpack_public_path__ + "img/alert.5404ed29.svg";